/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	// メインヴィジュアル
	const mainVisSwiper = () => {
		const mainVis = document.querySelector('.top-mainVis');
		if(!mainVis) return;
		const prevButton = mainVis.querySelector('.splide-arrow-prev');
		const nextButton = mainVis.querySelector('.splide-arrow-next');

		const splide = new Splide(mainVis, {
			type: 'fade',
			rewind: true,
			perPage: 1,
			autoplay: true,
			interval: 5000,
			speed: 500,
			arrows: false,
			pagination: true,
			paginationKeyboard: true,
			pauseOnHover: false,
		});

		// カスタムページネーションを設定
		splide.on('pagination:mounted', function (data) {
			data.list.classList.add('custom-pagination');
			
			data.items.forEach(function (item, index) {
				const slide = splide.Components.Elements.slides[index];
				item.button.innerHTML = '<svg class="circle-svg" viewBox="0 0 120 120"><circle class="circle-path" cx="60" cy="60" r="50" stroke="white" stroke-width="6" fill="none" /></svg>';
			});
		});

		splide.mount();

		if (prevButton && nextButton) {
			prevButton.addEventListener('click', () => {
				// '前へ' ボタンがクリックされたら、前のスライドへ移動
				splide.go('<');
			});

			nextButton.addEventListener('click', () => {
				// '次へ' ボタンがクリックされたら、次のスライドへ移動
				splide.go('>');
			});
		}
	};

	// TBCのスーパー脱毛は、処理完了した毛はずっと生えてきません
	const infofpaicToggle = () => {
		const btn = document.querySelector('.js-infofpaic-toggle');
		if(!btn) return;
		const list = document.querySelector('.top-infographic-list-wrap');
		if(!list) return;

		btn.addEventListener('click', () => {
			btn.classList.toggle(a);
			list.classList.toggle(a);
		});
	};

	// <EXPERIENCE> 脱毛の経過の画像切り替え
	const experienceImageToggle = () => {
		const toggleButton = document.querySelector('.js-experience-toggle');
		if(!toggleButton) return;

		const parentFrame = document.querySelector('.top-experience-frame');
		if(!parentFrame) return;

		const afterFrame = document.querySelector('.top-experience-frame-after');
		if(!afterFrame) return;

		let initialX;
		let xOffset = 0;
		let isDragging = false;

		// Get parent container dimensions for boundaries
		const parentRect = parentFrame.getBoundingClientRect();
		const toggleRect = toggleButton.getBoundingClientRect();

		// Calculate initial position in percentage
		const initialLeftPx = parseFloat(window.getComputedStyle(toggleButton).left) || 0;
		const initialLeftPercent = (initialLeftPx / parentRect.width) * 100;
		xOffset = initialLeftPercent; // Initialize xOffset with the current left position as percentage

		const minLeft = 0;
		const maxLeft = 100; // Changed from 100 - (toggleRect.width / parentRect.width) * 100 to 100

		// Set initial width of afterFrame (inverted)
		afterFrame.style.width = `${100 - initialLeftPercent}%`;

		toggleButton.addEventListener('mousedown', dragStart);
		toggleButton.addEventListener('touchstart', dragStart); // Add touch support

		function dragStart(e) {
			// Prevent default to avoid issues like image dragging
			e.preventDefault();
			
			const currentLeftPercent = parseFloat(toggleButton.style.left) || initialLeftPercent;
			
			if (e.type === 'touchstart') {
				initialX = e.touches[0].clientX - (currentLeftPercent / 100 * parentRect.width);
			} else {
				initialX = e.clientX - (currentLeftPercent / 100 * parentRect.width);
			}

			isDragging = true;

			// Add event listeners to the document to track movement globally
			document.addEventListener('mousemove', drag);
			document.addEventListener('touchmove', drag);
			document.addEventListener('mouseup', dragEnd);
			document.addEventListener('touchend', dragEnd);
		}

		function drag(e) {
			if (!isDragging) return;

			e.preventDefault();

			let currentX;
			if (e.type === 'touchmove') {
				currentX = e.touches[0].clientX;
			} else {
				currentX = e.clientX;
			}

			// Calculate position in percentage
			const newXOffset = ((currentX - initialX) / parentRect.width) * 100;
			
			// Constrain movement within parent container
			xOffset = Math.max(minLeft, Math.min(newXOffset, maxLeft));

			// Update the toggleButton's left position with percentage
			setTranslate(xOffset);
		}

		function dragEnd(e) {
			// Stop dragging
			isDragging = false;

			// Remove event listeners
			document.removeEventListener('mousemove', drag);
			document.removeEventListener('touchmove', drag);
			document.removeEventListener('mouseup', dragEnd);
			document.removeEventListener('touchend', dragEnd);
		}

		function setTranslate(xPos) {
			toggleButton.style.left = `${xPos}%`;
			// Update the width of top-experience-frame-after to be inverse of the toggle position
			afterFrame.style.width = `${100 - xPos}%`;
		}
		
	};

	// <EXPERIENCE> 脱毛の経過の画像切り替え（メンズ）
	const experienceImageToggleMens = () => {
		const toggleWrap = document.querySelectorAll('.js-imgToggle');
		if(!toggleWrap) return;
			toggleWrap.forEach((wrap) => {
				const beforeBtn = wrap.querySelector('.js-imgToggle-before');
				const afterBtn = wrap.querySelector('.js-imgToggle-after');
				const beforeImage = wrap.querySelector('.js-imgToggle-beforeImg');
				const afterImage = wrap.querySelector('.js-imgToggle-afterImg');
				if(!beforeBtn || !afterBtn || !beforeImage || !afterImage) return;
				beforeBtn.addEventListener('click', () => {
					beforeBtn.classList.add(a);
					afterBtn.classList.remove(a);
					beforeImage.classList.add(a);
					afterImage.classList.remove(a);
				});
				afterBtn.addEventListener('click', () => {
					afterBtn.classList.add(a);
					beforeBtn.classList.remove(a);
					beforeImage.classList.remove(a);
					afterImage.classList.add(a);
				});
			});
	};

	// <TBCが続けてきたこと> スライダー
	const commitmentSlider = () => {
		const slider = document.querySelector('.js-commitment-slider');
		if(!slider) return;

		const prevButton = slider.querySelector('.splide-arrow-prev');
		const nextButton = slider.querySelector('.splide-arrow-next');

		const splide = new Splide(slider, {
			type: 'fade',
			rewind: true,
			perPage: 1,
			arrows: false,
			cover: true,
			pagination: true,
			drag: window.innerWidth <= 1025,

		});

		// カスタムページネーションを設定
		splide.on('pagination:mounted', function (data) {
			data.list.classList.add('custom-pagination');
			
			data.items.forEach(function (item, index) {
				const slide = splide.Components.Elements.slides[index];
				const text = slide.dataset.paginationText || `スライド ${index + 1}`;
				item.button.innerHTML = `<span class="__num">0${index + 1}</span>${text}`;
			});
		});

		splide.mount();

		// --- 2つ目のカスタムページネーションの実装 ---
		const customBottomPagination = document.getElementById('custom-bottom-pagination');
		const slides = splide.root.querySelectorAll('.splide__slide'); // スライド要素を再取得

		// ページネーションのボタンを動的に生成
		slides.forEach((slide, index) => {
			const button = document.createElement('button');
			button.classList.add('splide__pagination__page', 'custom-pagination-button');
			button.setAttribute('type', 'button'); // アクセシビリティのため
			button.setAttribute('aria-controls', `main-carousel-slide${index + 1}`); // 関連付け
			button.setAttribute('aria-label', slide.dataset.paginationText);

			const text = slide.dataset.paginationText;
			button.innerHTML = `<span class="pagination-text">${text}</span>`;

			// クリックイベントでスライドを移動
			button.addEventListener('click', () => {
				splide.go(index);
			});

			customBottomPagination.appendChild(button);
		});

		// スライダーの移動イベントにフックして、アクティブなボタンを更新
		splide.on('moved', function (newIndex) {
			const currentActive = customBottomPagination.querySelector('.splide__pagination__page.is-active');
			if (currentActive) {
				currentActive.classList.remove('is-active');
			}
			customBottomPagination.querySelectorAll('.splide__pagination__page')[newIndex].classList.add('is-active');
		});

		// 初期ロード時に最初のボタンをアクティブにする
		if (customBottomPagination.querySelector('.splide__pagination__page')) {
			customBottomPagination.querySelector('.splide__pagination__page').classList.add('is-active');
		}

		if (prevButton && nextButton) {
			prevButton.addEventListener('click', () => {
				// '前へ' ボタンがクリックされたら、前のスライドへ移動
				splide.go('<');
			});

			nextButton.addEventListener('click', () => {
				// '次へ' ボタンがクリックされたら、次のスライドへ移動
				splide.go('>');
			});
		}
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const topFUNCTIONS = () => {
		mainVisSwiper();
		infofpaicToggle();
		experienceImageToggle();
		experienceImageToggleMens();
		commitmentSlider();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { topFUNCTIONS(); }) : topFUNCTIONS();

})(window.FUNCTIONS);
